const globals = {
  dashboard: {
    icon: "dashboard-icon",
    title: "Dashboard",
  },
  createuser: {
    icon: "invitation-icon",
    title: "Create User",
  },
  Roll: {
    icon: "invitation-icon",
    title: "Role",
  },
  Package: {
    icon: "invitation-icon",
    title: "Package",
  },
  Customer: {
    icon: "invitation-icon",
    title: "Customer",
  },
  Reports: {
    icon: "invitation-icon",
    title: "Reports",
  },
  Application: {
    icon: "invitation-icon",
    title: "Application",
  },
  admin: {
    icon: "invitation-icon",
    title: "Admin",
  },
  TestRegister: {
    icon: "invitation-icon",
    title: "TestRegister",
  },
};

export default globals;
